import { Icon } from '@components/Icon';
import React, { useEffect, useState } from 'react';

interface AccordionProps {
  header: React.ReactNode;
  initiallyOpen?: boolean;
  forceOpen?: boolean;
  children?: React.ReactNode;
  onExpand?: () => void;
}

const Accordion: React.FC<AccordionProps> = ({
  header,
  initiallyOpen = false,
  forceOpen = false,
  children,
  onExpand,
}) => {
  const [isOpen, setIsOpen] = useState(initiallyOpen);
  const [isOpenHidden, setIsOpenHidden] = useState(initiallyOpen);

  const handleToggle = () => {
    setIsOpen(!isOpen);
    setIsOpenHidden(!isOpen);

    if (onExpand && !isOpen) {
      onExpand();
    }
  };

  useEffect(() => {
    if (forceOpen) {
      setIsOpen(true);
    } else {
      setIsOpen(isOpenHidden);
    }
  }, [forceOpen, isOpenHidden]);

  return (
    <>
      <div className={isOpen || forceOpen ? 'accordion__container--open' : ''}>
        <div
          className="d-flex accordion justify-between align-items-center  pointer border-secondary w-100"
          onClick={handleToggle}
        >
          <span className="w-100">{header}</span>
          <span data-testid="accordion-icon">
            <Icon className="text-primary">
              {isOpen ? 'expand_less' : 'expand_more'}
            </Icon>
          </span>
        </div>

        {isOpen && (
          <div className="accordion__content" data-testid="accordion-content">
            {children}
          </div>
        )}
      </div>
    </>
  );
};

export default Accordion;
